import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import Navbar from "src/components/home/Navbar";
import { Box } from "@mui/material";

interface BlogLayoutProps {
	children?: ReactNode;
}

const BlogLayout: FC<BlogLayoutProps> = ({ children }) => {
	return (
		<Box sx={{ backgroundColor: "white", height: "100vh" }}>
			<Navbar />
			<Box sx={{ position: "relative"  }}>
				{children || <Outlet />}
			</Box>
			{/* <Footer /> */}
		</Box>
	);
};

BlogLayout.propTypes = {
	children: PropTypes.node,
};

export default BlogLayout;
